import { message } from "antd";
import internalApi from "../axios/internalApi";

export const getNewBusinesses = async (
  { pageNumber = 1, itemPerPage = 10, text = null, isLoadMore = false },
  queryString
) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/business/list?${
        queryString ? `${queryString}&` : ""
      }pageNumber=${(text && !isLoadMore) ? 1 : pageNumber}&itemPerPage=${itemPerPage}${
        text ? `&text=${text}` : ""
      }`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getBusinessById = async (id) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/business/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const approveBusiness = async (id, payload) => {
  try {
    return await internalApi.patch(
      { server: "api/v1/", path: `admin/business/${id}` },
      payload
      // { isApproved: true }
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const pauseBusinessSubscription = async (payload) => {
  try {
    return await internalApi.patch(
      { server: "api/v1/", path: `admin/pause-subscription` },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const resumeBusinessSubscription = async (payload) => {
  try {
    return await internalApi.patch(
      { server: "api/v1/", path: `admin/resume-subscription` },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const giveFreeAds = async (payload) => {
  try {
    return await internalApi.patch({
      server: "api/v1/",
      path: `admin/ads/free?businessId=${payload.businessId}&${
        payload.isFreeAds ? "isFreeAds=true" : ""
      }`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const addBusinessType = async (payload) => {
  try {
    return await internalApi.post(
      { server: "api/v1/", path: "admin/create-business-type" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getBusinessTypes = async () => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: "business-type/list",
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const updateBusinessType = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/business-type/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getBusinessAnalytics = async (id) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `analytics/admin?businessId=${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deleteBusiness = async (id) => {
  try {
    return await internalApi.delete({
      server: "api/v1/",
      path: `admin/delete-business/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const enableBusinessMessages = async (id, payload) => {
  try {
    return await internalApi.patch(
      {
        server: "api/v1/",
        path: `admin/enable-messages/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
}

export const generateVendorAccessToken = async (vendorId) => {
  try {
    return await internalApi.post(
      { server: "api/v1/", path: `admin/generate-vendor-access-token/${vendorId}`},
    );
  } catch (error) {
    message.error(error?.data?.message);
    return null;
  }
}
